<!-- //
点击...在item上弹出菜单
@auth xuyd
@date 2025-05-04
//-->
<template>
  <ul class="context-menu" :style="{left:ctxData.left + 'px',top: ctxData.top + 'px'}" v-show="visible">
    <li :class="{}" @click.stop="handleMenuCmd('download')">
      <i class="el-icon-close"></i><span class="label">下载</span>
    </li>
    <li :class="{}" @click.stop="handleMenuCmd('delete')">
      <i class="el-icon-close"></i><span class="label">删除</span>
    </li>
  </ul>
</template>

<script>

export default {
  name: 'CompContextMenu',
  data() {
    return {
      visible: false,
      ctxData: {
        left: 0,
        top: 0,
        rowData: {id: null, title: null}
      },
    };
  },
  watch: {
    visible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeMenu);
      } else {
        document.body.removeEventListener("click", this.closeMenu);
      }
    },
  },
  methods: {
    openMenu(data) {
      this.visible = true;
      this.ctxData = {...data};
    },
    closeMenu() {
      this.visible = false;
    },

    isTopView() {
      return this.ctxData.rowData.isHead;
    },
    isBottomView() {
      return this.ctxData.rowData.isTail;
    },

    /**
     * 菜单上下文操作，上移动，下移动，复制，删除
     * 菜单操作都执行db操作
     *
     * @param command
     * @param disable
     */
    handleMenuCmd(command, disable) {
      if(disable) return;
      let item = this.ctxData.rowData;
      this.$emit('command', command, item);
    }
  }
}
</script>
<style lang="less" scoped>

.context-menu {
  margin: 0;
  width: 100px;
  background-color: #FFFFFF;
  z-index: 9999;
  position: fixed;
  list-style-type: none;
  padding: 5px 5px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);

  .disable {
    color: #8C8C8C;
  }

  li {
    margin: 0;
    padding: 10px;
    cursor: pointer;

    .label {
      margin-left: 10px;
    }
  }

  li:not(.disable):hover {
    background-color: #f1f1f1;
  }

}
</style>
